import sessionData from '../Components/UI/Session/getSession';

const NoAuth = ()=> {
    return sessionData('sessionData')
        ? true
        : false;

};
export default NoAuth;
